import { AddressStatus } from '@/models/address';

export const deactivateAllAddresses = <T extends { status?: AddressStatus }>(
  addresses: T[],
): T[] =>
  addresses.map((addr) => ({ ...addr, status: AddressStatus.INACTIVE }));

export const hasActiveAddress = (
  addresses: ReadonlyArray<{ status?: AddressStatus } | null | undefined>,
): boolean => addresses.some((a) => a?.status === AddressStatus.ACTIVE);
